import { MessageOutlined } from "@ant-design/icons";

interface ChatMessageProps {
  avatar: string;
  children: string;
  name: string;
  own?: boolean;
  tone: "blue" | "cyan" | "orange" | "rose";
  urgent?: boolean;
}

const ChatMessage = ({
  avatar,
  children,
  name,
  own = false,
  tone,
  urgent = false,
}: ChatMessageProps) => (
  <div
    className={`abstractMessage${own ? " abstractMessage--own" : ""}${
      urgent ? " abstractMessage--urgent" : ""
    }`}
  >
    <span className={`abstractMessage__avatar abstractMessage__avatar--${tone}`}>
      {avatar}
    </span>
    <div>
      <small>{name}</small>
      <p>{children}</p>
    </div>
  </div>
);

const AbstractChatScene = () => (
  <section className="authScene" aria-label="抽象团队聊天场景">
    <div className="authScene__brand">
      <span className="authScene__mark">
        <img src="/heltec-logo.png" alt="HELTEC" />
      </span>
      <div>
        <strong>HELTEC内部管理平台，非专业内部人士退！退！退！</strong>
        <small>PROJECT FLOW / 2026</small>
      </div>
    </div>

    <div className="authScene__tracks" aria-hidden="true">
      <span />
      <span />
      <span />
      <i />
      <i />
      <i />
    </div>

    <article className="abstractChat abstractChat--main">
      <header>
        <div>
          <MessageOutlined />
          <strong>今天不加班（8）</strong>
        </div>
        <time>16:28</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="软" name="软件组" tone="orange">
          软件开发没前途
        </ChatMessage>
        <ChatMessage avatar="我" name="我" own tone="blue">
          那这个需求还做吗？
        </ChatMessage>
        <ChatMessage avatar="产" name="产品" tone="cyan">
          先排进本周计划
        </ChatMessage>
      </div>
      <footer>
        <span>7 人已读</span>
        <i />
      </footer>
    </article>

    <article className="abstractChat abstractChat--question">
      <header>
        <div>
          <MessageOutlined />
          <strong>临时讨论组</strong>
        </div>
        <time>17:03</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="?" name="神秘成员" tone="rose">
          谁是王海军？
        </ChatMessage>
        <ChatMessage avatar="测" name="测试" tone="cyan">
          我只知道这个节点卡了三天
        </ChatMessage>
      </div>
    </article>

    <article className="abstractChat abstractChat--launch">
      <header>
        <div>
          <MessageOutlined />
          <strong>上线作战室</strong>
        </div>
        <time>刚刚</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="产" name="产品" tone="orange">
          今天能上线吗？
        </ChatMessage>
        <ChatMessage avatar="我" name="我" own tone="blue">
          可以，先把验收人拉进来
        </ChatMessage>
      </div>
    </article>

    <article className="abstractChat abstractChat--scope">
      <header>
        <div>
          <MessageOutlined />
          <strong>需求变更群</strong>
        </div>
        <time>18:46</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="产" name="产品" tone="cyan">
          这个按钮点一下就行
        </ChatMessage>
        <ChatMessage avatar="开" name="开发" own tone="blue">
          权限、审批和日志也默认有？
        </ChatMessage>
        <ChatMessage avatar="领" name="领导" tone="rose">
          这个需求做得怎么样了
        </ChatMessage>
        <ChatMessage avatar="洪" name="洪总" own tone="cyan">
          应该差不多大概可以了吧
        </ChatMessage>
      </div>
    </article>

    <article className="abstractChat abstractChat--deadline">
      <header>
        <div>
          <MessageOutlined />
          <strong>上线时间确认群</strong>
        </div>
        <time>18:58</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="领" name="领导" tone="rose" urgent>
          今天上线
        </ChatMessage>
        <ChatMessage avatar="开" name="开发" own tone="blue">
          今天指的是哪天？
        </ChatMessage>
        <ChatMessage avatar="项" name="项目经理" tone="orange">
          就今天，下班前
        </ChatMessage>
        <ChatMessage avatar="开" name="开发" own tone="blue">
          那下班又是几点？
        </ChatMessage>
      </div>
    </article>

    <article className="abstractChat abstractChat--handoff">
      <header>
        <div>
          <MessageOutlined />
          <strong>排期核对群</strong>
        </div>
        <time>19:02</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="项" name="项目经理" tone="orange">
          这个版本今晚能定吗？
        </ChatMessage>
        <ChatMessage avatar="开" name="开发" own tone="blue">
          能，前提是需求别再长大。
        </ChatMessage>
        <ChatMessage avatar="领" name="领导" tone="rose" urgent>
          那再加一个很小的改动
        </ChatMessage>
        <ChatMessage avatar="毛" name="长毛" tone="cyan">
          这叫小改啊？
        </ChatMessage>
        <ChatMessage avatar="产" name="产品" tone="orange">
          就改三个页面和两套流程
        </ChatMessage>
        <ChatMessage avatar="开" name="开发" own tone="blue">
          明白，排期不动，睡眠顺延
        </ChatMessage>
      </div>
    </article>

    <article className="abstractChat abstractChat--directive">
      <header>
        <div>
          <MessageOutlined />
          <strong>需求评审群</strong>
        </div>
        <time>18:31</time>
      </header>
      <div className="abstractChat__body">
        <ChatMessage avatar="领" name="领导" tone="rose">
          这个需求很简单
        </ChatMessage>
        <ChatMessage avatar="领" name="领导" tone="rose">
          怎么实现我不管
        </ChatMessage>
        <ChatMessage avatar="领" name="领导" tone="rose" urgent>
          明天上线
        </ChatMessage>
      </div>
    </article>

    <div className="authScene__caption">
      <span>
        <i /> 频道保持在线
      </span>
      <h1>有些项目，从领导的一句话开始。</h1>
      <p>领导负责一句话，剩下的交给排期、加班和奇迹。</p>
    </div>
  </section>
);

export default AbstractChatScene;
